// @module AA.SerialNumberPDP.SerialNumber
define('C3.PD.InventoryImages.View'
,	[
	'tekyard_pd_inventoryimages.tpl'
	
	,	'AjaxRequestsKiller'
	
	,	'Backbone'
	,   'Utils'
	,   'Utilities.ResizeImage'
	,   'zoom'
	
    ]
, function (
	tekyard_pd_inventoryimages_tpl
	
	,	AjaxRequestsKiller
	
	,	Backbone
	,   Utils
	,   resizeImage
)
{
    'use strict';

	// @class AA.SerialNumberPDP.SerialNumber.View @extends Backbone.View
	return Backbone.View.extend({

		template: tekyard_pd_inventoryimages_tpl

	,	initialize: function (options) {
			
			this.model = options.model || new Backbone.Model();
			this.images = options.inventoryimages;
            this.isZoomEnabled = SC.CONFIGURATION.isZoomEnabled;

            this.images = _.map(this.images, function (img) {
                if (!img.type) {
                    img.type = 'image';
                }
                return img;
            });

	        this.once('afterViewRender', function () {
			    this.initSliderZoom(true);
			});

	    }

	,	events: {
			'contextmenu .serial-item-image-gallery': 'preventDownload'
		,   'dragstart .serial-item-image-gallery img': 'preventDownload'
		}

	,   preventDownload: function(e) {
            e.preventDefault();
            return false;
        }

	,	bindings: {
		}


	, 	childViews: {
			
		}

	,  initSliderZoom: function initSliderZoom(forceInit) {
    	this.initSlider(forceInit);
        // Zoom is initialized in onSliderLoad callback for multi-image
        // For single image, init zoom here
        if (this.isZoomEnabled && this.images && this.images.length === 1) {
            this.initZoom();
        }
    }

    // @method initSlider Initialize the bxSlider
    // @return {Void}
    ,   initSlider: function initSlider(forceInit) {
            var self = this;

            if (this.images && this.images.length > 1 && (!this.$slider || forceInit === true)) {
                this.$slider = Utils.initBxSlider(this.$('[data-slider]'), {
                    buildPager: _.bind(this.buildSliderPager, this),
                    startSlide: 0,
                    adaptiveHeight: true,
                    touchEnabled: true,
                    controls: true,

                    // when slider first loads
                    onSliderLoad: function () {
                        // Initialize zoom after slider DOM is ready
                        if (self.isZoomEnabled) {
                            self.initZoom();
                        }

                        var $pager = self.$('.bx-custom-pager');
                        var $viewport = self.$('.bx-viewport');

                        if ($pager.length && $viewport.length) {
                            if (!$pager.parent().hasClass('custom-pager-wrapper')) {
                                $pager.wrap('<div class="custom-pager-wrapper"></div>');
                            }
                            var $wrapper = $pager.parent();

                            // add up/down buttons if not present
                            if (!$wrapper.find('.pager-up').length) {
                                $wrapper.prepend('<button type="button" class="pager-up">▲</button>');
                                $wrapper.append('<button type="button" class="pager-down">▼</button>');
                            }

                            var $up = $wrapper.find('.pager-up');
                            var $down = $wrapper.find('.pager-down');

                            var scrollAmount = 100; // px per click

                            $up.on('click', function () {
                                $pager.animate({ scrollTop: $pager.scrollTop() - scrollAmount }, 250);
                            });

                            $down.on('click', function () {
                                $pager.animate({ scrollTop: $pager.scrollTop() + scrollAmount }, 250);
                            });

                            function syncPagerHeight() {
                                // Only apply height sync on desktop (>= 768px)
                                if (jQuery(window).width() >= 768) {
                                    var viewportHeight = $viewport.height();
                                    var arrowHeight = $up.outerHeight(true) + $down.outerHeight(true); // include margins
                                    var scrollAreaHeight = viewportHeight - arrowHeight;

                                    $wrapper.height(viewportHeight);
                                    $pager.height(scrollAreaHeight);
                                } else {
                                    // Clear inline heights on mobile
                                    $wrapper.css('height', '');
                                    $pager.css('height', '');
                                }
                            }


                            syncPagerHeight();
                            jQuery(window).on('resize', _.debounce(syncPagerHeight, 150));

                            // Add mobile horizontal arrows
                            self.initMobilePagerArrows($pager, $wrapper);
                        }
                    },

                    // when slide changes
                    onSlideAfter: function () {
                        var $viewport = self.$('.bx-viewport');
                        var $wrapper = self.$('.custom-pager-wrapper');
                        if ($viewport.length && $wrapper.length) {
                            $wrapper.height($viewport.height());
                        }
                    }
                });

                this.$('[data-action="next-image"]').off();
                this.$('[data-action="prev-image"]').off();

                this.$('[data-action="next-image"]').click(_.bind(this.nextImageEventHandler, this));
                this.$('[data-action="prev-image"]').click(_.bind(this.previousImageEventHandler, this));
            }
        },




    // @method previousImageEventHandler Handle the clicking over the previous button to show the previous main image. It does it by triggering a cancelable event.
    // @return {Void}
    previousImageEventHandler: function previousImageEventHandler() {
        const self = this;
        const current_index = self.$slider.getCurrentSlide();
        const next_index =
            current_index === 0 ? self.$slider.getSlideCount() - 1 : current_index - 1;

        // IMPORTANT This event is used to notify the ProductDetails.Component that the images have changed
        // @event {ProductDetails.ImageGallery.ChangeEvent} 'afterChangeImage
        self.model
            .cancelableTrigger('beforeChangeImage', {
                currentIndex: current_index,
                nextIndex: next_index
            })
            .then(function() {
                self.$slider.goToPrevSlide();
                self.model.cancelableTrigger('afterChangeImage', next_index);
            });
    },

    // @method nextImageEventHandler Handle the clicking over the next button to show the next main image. It does it by triggering a cancelable event
    // @return {Void}
    nextImageEventHandler: function nextImageEventHandler() {
        const self = this;
        const current_index = self.$slider.getCurrentSlide();
        const next_index =
            current_index === self.$slider.getSlideCount() - 1 ? 0 : current_index + 1;

        // IMPORTANT This event is used to notify the ProductDetails.Component that the images have changed
        // @event {ProductDetails.ImageGallery.ChangeEvent} beforeChangeImage
        self.model
            .cancelableTrigger(
                'beforeChangeImage',
                // @class ProductDetails.ImageGallery.ChangeEvent Image change event information container
                {
                    // @property {Number} currentIndex
                    currentIndex: current_index,
                    // @property {Number} nextIndex
                    nextIndex: next_index
                }
                // @class ProductDetails.ImageGallery.View
            )
            .then(function() {
                self.$slider.goToNextSlide();
                self.model.cancelableTrigger('afterChangeImage', next_index);
            });
    }

    ,  initZoom: function() {
        const self = this;
        if (!SC.ENVIRONMENT.isTouchEnabled) {
            const images = this.images;
            this.$('[data-zoom]:not(.bx-clone)').each(function(slide_index) {
                var img = images[slide_index];
                // Only zoom regular images, not 360 iframes
                if (img && img.url && img.type !== 'html360') {
                    // Custom zoom implementation - fixes transform-origin calculation
                    var $container = self.$(this);
                    var $img = $container.children('img').first();
                    var zoomUrl = resizeImage(img.url, 'zoom');
                    
                    if ($img.length) {
                        $container.css({ position: 'relative', overflow: 'hidden' });
                        
                        $container.on('mouseover.customzoom', function() {
                            $img.css({ transform: 'scale(2.3)' });
                        });
                        
                        $container.on('mouseout.customzoom', function() {
                            $img.css({ transform: 'scale(1)' });
                        });
                        
                        $container.on('mousemove.customzoom', function(e) {
                            // Get the actual img DOM element
                            var imgEl = $img[0];
                            if (!imgEl) return;
                            
                            // Use getBoundingClientRect for accurate dimensions
                            var rect = imgEl.getBoundingClientRect();
                            var imgWidth = rect.width;
                            var imgHeight = rect.height;
                            
                            // Safety check - don't calculate if dimensions not available
                            if (imgWidth < 10 || imgHeight < 10) return;
                            
                            // Calculate mouse position relative to image
                            // e.clientX/Y are relative to viewport, same as getBoundingClientRect
                            var xPercent = ((e.clientX - rect.left) / imgWidth) * 100;
                            var yPercent = ((e.clientY - rect.top) / imgHeight) * 100;
                            
                            // Clamp to 0-100 range
                            xPercent = Math.max(0, Math.min(100, xPercent));
                            yPercent = Math.max(0, Math.min(100, yPercent));
                            
                            $img.css({
                                'transform-origin': xPercent + '% ' + yPercent + '%'
                            });
                        });
                        
                        if (zoomUrl) {
                            $img.attr('src', zoomUrl);
                        }
                    }
                }
            });
        }
    },

    // Mobile horizontal pager arrows
    initMobilePagerArrows: function($pager, $wrapper) {
        // Only on mobile
        if (jQuery(window).width() >= 768) {
            return;
        }

        // Add left/right buttons for horizontal scroll
        if (!$wrapper.find('.pager-left').length) {
            $wrapper.prepend('<button type="button" class="pager-left">◀</button>');
            $wrapper.append('<button type="button" class="pager-right">▶</button>');
        }

        var $left = $wrapper.find('.pager-left');
        var $right = $wrapper.find('.pager-right');
        var scrollAmount = 80; // px per click

        $left.on('click', function() {
            $pager.animate({ scrollLeft: $pager.scrollLeft() - scrollAmount }, 250);
        });

        $right.on('click', function() {
            $pager.animate({ scrollLeft: $pager.scrollLeft() + scrollAmount }, 250);
        });
    },

    // @method buildSliderPager
    // @param {Number} slide_index
    // @return {String}
      buildSliderPager: function (slide_index) {
            const image = this.images[slide_index];
            if (!image) {
                return;
            }

            if (image.type === 'html360') {
                var thumb = image.thumbUrl || image.url;
                return (
                    '<div class="serial-thumb-360">' +
                        '<img src="' + resizeImage(thumb, 'tinythumb') + '" alt="360° view">' +
                        //'<span class="serial-thumb-360-icon">360°</span>' +
                    '</div>'
                );
            }

            return (
                '<img src="' +
                resizeImage(image.url, 'tinythumb') +
                '" alt="' +
                (image.altimagetext || '') +
                '">'
            );
        }


		//@method getContext @return AA.SerialNumberPDP.SerialNumber.View.Context
	,	getContext: function getContext() {
            var images = this.images || [];

            // decorate each image with convenience flags for the template
            var imagesUpdated = _.map(images, function (img) {
                img.isHtml360 = img.type === 'html360';
                return img;
            });

            var firstImageUpdated = images[0] || {};
            firstImageUpdated.isHtml360 = firstImageUpdated.type === 'html360';

            return {
                imageResizeId: Utils.getViewportWidth() < 768 ? 'thumbnail' : 'main',
                imagesUpdated: imagesUpdated,
                firstImageUpdated: firstImageUpdated,
                showImages: images && images.length > 0,
                showImageSlider: images && images.length > 1,
                isPhoneDevice: Utils.isPhoneDevice()
            };
        }

	});
});
